export default "__VITE_ASSET__Cut6U4SE__"